import { render, staticRenderFns } from "./page-index.vue?vue&type=template&id=476e66b0&"
import script from "./page-index.vue?vue&type=script&lang=js&"
export * from "./page-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports